export default __webpack_public_path__ + "static/media/cub_logo.bff76d8f.png";